export default __webpack_public_path__ + "static/media/gender_select_icon.124c7d44.svg";